// Inscription du service worker et détection des mises à jour.

let enAttente = null;
const abonnes = new Set();
const notifier = () => abonnes.forEach((f) => f(Boolean(enAttente)));

export function surMajDisponible(f) {
  abonnes.add(f);
  f(Boolean(enAttente));
  return () => abonnes.delete(f);
}

export async function inscrire() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      // Ceinture et bretelles avec le no-cache de Caddy : interdit au cache HTTP de
      // servir sw.js lui-même. Un service worker périmé sur une app installée est un
      // cul-de-sac, il n'y a plus de barre d'adresse pour forcer un rechargement.
      updateViaCache: 'none',
    });

    const surveiller = (sw) => {
      if (!sw) return;
      const verifier = () => {
        // 'installed' avec un contrôleur déjà en place = une nouvelle version attend.
        if (sw.state === 'installed' && navigator.serviceWorker.controller) { enAttente = sw; notifier(); }
      };
      verifier();
      sw.addEventListener('statechange', verifier);
    };

    surveiller(reg.waiting);
    reg.addEventListener('updatefound', () => surveiller(reg.installing));

    let rechargement = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (rechargement) return;
      rechargement = true;
      location.reload();
    });

    // Sur iOS c'est `visibilitychange` qui compte : une application installée n'est
    // presque jamais démarrée à froid, elle est réveillée. S'en tenir au démarrage,
    // c'est une mise à jour détectée des semaines plus tard.
    const verifier = () => reg.update().catch(() => {});
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') verifier();
    });
    window.addEventListener('online', verifier);
    verifier();

    return reg;
  } catch {
    // Pas de service worker : l'application fonctionne quand même, simplement sans
    // démarrage hors-ligne. Ce n'est pas une raison de ne rien afficher.
    return null;
  }
}

export function appliquerMaj() {
  enAttente?.postMessage({ type: 'APPLIQUER_MAJ' });
}
